<template>
  <div class="recharge_left">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <h4>{{ $t('pc.myaccount.risk_control_notification') }}</h4>
      </div>
      <el-card class="box-card rishControl" shadow="hover" v-for="(item,index) in riskControl" :key="index">
        <h4>{{ $getDeviceTime(item.time) }}</h4>
        <div v-html="translateSystemKeys(item.detail)"></div>
      </el-card>
      <div class="changePage">
        <el-button type="primary" icon="el-icon-arrow-left" size="mini">{{ $t('pc.myaccount.previous_page') }}</el-button>
        <el-button type="primary" icon="el-icon-arrow-right" size="mini" style="float: right">{{ $t('pc.myaccount.next_page') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
    export default {
      name: "riskControl",
      data(){
        return{
          riskControl:[]
        }
      },
      methods:{
        translateSystemKeys(detail) {
          if (!detail) return "";

          // Replace any system.* key with its i18n value
          return detail.replace(/system\.[\w.]+/g, (match) => {
            return this.$t(match);
          });
        },
        getRiskControl(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "risk_control",
              token: sessionStorage.getItem("token"),
              page:1,
              num:20
            }
          })
          .then(function (res) {
            let resData = res.data;
            if (resData.code === 1){
              that.riskControl = resData.data;
            }else if (resData.code === 0){
              that.$message.error(that.$t(resData.msg));
            }
          })
        }
      },
      mounted() {
        this.getRiskControl();
      }
    }
</script>

<style scoped>
  .rishControl h4{
    font-size: 16px;
  }
  .rishControl p{
    font-size: 14px;
    color: #909399;
  }
  .changePage{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/riskControl.vue